<div class="title">Manage banners/ads</div>

<span *ngFor="let item of bannerPositions?.headBannerPositions">
  <div *ngFor="let bannerPosition of bannerPositions?.bannerPositions[item]">
    <div
      *ngIf="
        bannerPosition.bannerPositionId == bannerPosition.headBannerPositionId;
        else elseBlock
      "
      class="head-banner"
    >
      {{ bannerPosition.name }}
    </div>
    <ng-template #elseBlock>
      <a
        [routerLink]="[
          '/settings/banner-positions',
          bannerPosition.bannerPositionId,
          'banners'
        ]"
        class="banner"
      >
        {{ bannerPosition.name }}
      </a>
      <div class="banner-size">
        {{ bannerPosition.desktopWidth }}x{{ bannerPosition.desktopHeight }} |
        {{ bannerPosition.responsiveWidth }}x{{
          bannerPosition.responsiveHeight
        }}
      </div>
    </ng-template>
  </div>
</span>
